import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { reminderEngine } from '../../services/reminderEngine';
import { bindPushOwner } from '../../services/browserPush';
import { notificationHistory } from '../../services/database';

export default function ReminderRunner() {
  const { user, loading } = useAuth();
  const [notice, setNotice] = useState(null);
  useEffect(() => {
    if (loading || !user?.id) return;
    const notify = event => setNotice(event.detail);
    window.addEventListener('spcc:reminder', notify);
    bindPushOwner(user.id).catch(() => {});
    reminderEngine.start();
    return () => { reminderEngine.stop(); bindPushOwner(null).catch(() => {}); setNotice(null); window.removeEventListener('spcc:reminder', notify); };
  }, [user?.id, loading]);
  return notice && <aside className="v2-notice" role="status"><strong>{notice.title}</strong><Link to="/reminders">View reminders</Link><button aria-label="Dismiss notification" onClick={() => { notificationHistory.update(notice.id, { read_at: new Date().toISOString() }).catch(() => {}); setNotice(null); }}>Dismiss</button></aside>;
}
